<template>
  <v-dialog
    v-model="dialogRegisterUser"
    persistent
    max-width="800px"
    @click:outside="close()"
  >
    <template #activator="{}">
      <v-tooltip
        bottom
        max-width="200px"
        open-delay="750"
      >
        <template #activator="{ on, attrs }">
          <div v-on="on">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              @click="dialogRegisterUser = true"
            >
              <v-icon>fa-user-plus</v-icon>
            </v-btn>
          </div>
        </template>
        <span>
          Dieser Button öffnet ein Feld, in dem sich ein Nutzer registrieren
          kann.
        </span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        <span class="text-h5"> Registrierung </span>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-container>
          <v-form ref="form">
            <v-row>
              <v-col
                cols="12"
                class="dotted-bottom"
              >
                <h4>Ihr Unternehmen</h4>
                <v-text-field
                  v-model="register_user.clientName"
                  placeholder="Energieversorung-Stuttgart"
                  label="Unternehmen / Organisation"
                  :rules="fieldRules"
                />
              </v-col>
              <v-col cols="12">
                <h4>Ihr Nutzer</h4>
                <v-autocomplete
                  v-model="register_user.salutation"
                  :items="salutations"
                  label="Anrede"
                  :rules="fieldRules"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="register_user.title"
                  placeholder="Dr."
                  label="Titel"
                  :rules="titleRules"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="register_user.firstname"
                  placeholder="Max"
                  label="Vorname"
                  :rules="fieldRules"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="register_user.lastname"
                  placeholder="Mustermann"
                  label="Nachname"
                  :rules="fieldRules"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="register_user.email"
                  placeholder="Max.Mustermann@mamu.de"
                  label="Email"
                  :rules="emailRules"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="register_user.password"
                  placeholder="*****"
                  label="Password"
                  :append-icon="pwVisibility ? 'fa-eye' : 'fa-eye-slash'"
                  :type="pwVisibility ? 'text' : 'password'"
                  :rules="fieldRules"
                  @click:append="pwVisibility = !pwVisibility"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="password_repeat"
                  placeholder="*****"
                  label="Password wiederholen"
                  :type="pwVisibility ? 'text' : 'password'"
                  :rules="[
                    (v) => !!v || 'die Passwordwiederholung ist erforderlich',
                    (v) =>
                      v === register_user.password ||
                      'die Passwörter müssen übereinstimmen',
                  ]"
                />
              </v-col>
              <v-col cols="12">
                <p>
                  Mit Ihrer Registrierung erklären Sie, dass Sie unsere
                  <a
                    href="https://www.spicetech.de/datenschutzerklaerung/"
                    target="_blank"
                  >Datenschutzerklärung</a>
                  zur Kenntnis genommen haben.
                </p>
                <p>
                  Sie verwenden QUANTICY im Rahmen Ihres kostenfreien Zugangs
                  als reine Testversion. Im Rahmen dieser Testversion erfolgt
                  keine Validierung der Eingangsdaten und Geodaten. Die
                  Spicetech GmbH übernimmt keinerlei Haftung für die generierten
                  Ergebnisse.
                </p>
              </v-col>
            </v-row>
          </v-form>
          <v-col v-if="errorMsg.length > 0">
            <div
              v-for="key of Object.keys(errorMsg)"
              :key="key"
              class="d-flex flex-column"
              style="color: #b71c1c"
            >
              {{ errorMsg[key] }}
            </div>
          </v-col>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close"
        >
          Abbrechen
        </v-btn>
        <v-btn
          :key="disableSubmitButton ? 'disabled' : 'activated'"
          color="primary"
          text
          :disabled="disableSubmitButton"
          @click="save()"
        >
          Registrieren
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "RegisterUserDialog",
  data: () => ({
    errorMsg: {},
    dialogRegisterUser: false,
    pwVisibility: false,

    salutations: ["Herr", "Frau", "Keine Angabe"],
    titleRules: [
      v =>
        !v ||
        v.length <= 20 ||
        "Der Titel muss kleiner gleich 20 Zeichen lang sein"
    ],
    fieldRules: [v => !!v || "das Feld ist erforderlich"],
    emailRules: [
      v => !!v || "E-Mail ist erforderlich",
      v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "die E-Mail muss gültig sein"
    ],
    register_user: {},
    password_repeat: ""
  }),
  computed: {
    validateFields() {
      return (
        this.register_user.clientName &&
        this.register_user.clientName.length > 0 &&
        this.register_user.salutation &&
        this.register_user.salutation.length > 0 &&
        this.register_user.firstname &&
        this.register_user.firstname.length > 0 &&
        this.register_user.lastname &&
        this.register_user.lastname.length > 0 &&
        this.register_user.email &&
        this.register_user.email.length > 0 &&
        this.register_user.password &&
        this.register_user.password.length > 0 &&
        this.register_user.password === this.password_repeat &&
        (!this.register_user.title || this.register_user.title?.length <= 20)
      );
    },

    disableSubmitButton() {
      return Object.keys(this.errorMsg).length > 0 || !this.validateFields;
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: "showSnackbar"
    }),
    save() {
      $api
        .post("registration", this.register_user)
        .then(res => {
          console.log(res.data);
          this.showSnackbar({
            text: "Nutzer erfolgreich angelegt",
            timeout: 3000,
            type: "success"
          });
          this.dialog_register_user = false;
          this.close();
        })
        .catch(error => {
          if (error.response.status == 409) {
            this.showSnackbar({
              text: "Registrierung fehlgeschlagen: E-Mail ist bereits mit einem anderen Account verknüpft",
              timeout: -1,
              type: "error"
            });
          }
        });
    },

    close() {
      this.resetData();
      this.dialogRegisterUser = false;
      this.$emit("close");
    },

    resetData() {
      this.errorMsg = {};
      this.password_repeat = "";
    }
  }
};
</script>

<style scoped>
.dotted-bottom {
  border-bottom: 2px dotted grey;
}
</style>
